export function validLogLevel(logLevel) {
  if (!isValidLogLevel(logLevel)) {
    throw new Error(`Invalid log level ${logLevel}`);
  }
  return logLevel;
}
export function isValidLogLevel(logLevel) {
  return logLevel in logLevelValueMapping;
}
/**
 * Defines the log levels and their corresponding values. The higher the value, the more verbose the log level. Beeing trace the most verbose and fatal the least.
 */
export const logLevelValueMapping = {
  fatal: 0,
  error: 1,
  warn: 2,
  info: 3,
  debug: 4,
  trace: 5
};
